<template>
<div>
  <div class="create-base" style='display:flex '>
    <div class="base-input">
      <el-input
        v-model="formData.textInput"
        size="small"
        style="width:200px"
        
        placeholder="请输入文字,建议10个字以内"
        maxlength="10"
        @input="textChange"
      ></el-input>
    </div>

    <div class="base-input" >
      <el-select
      style="width:100px"
        size="small"
        v-model="formData.familyInput"
        placeholder="请选择字体"
        @change="familyChange"
      >
        <el-option
          v-for="item in options"
          :key="item.value"
          :label="item.label"
          :value="item.value"
        >
        </el-option>
      </el-select>
      
    </div>
    <div class="base-input">
      <el-input-number
       style="width:100px"
        v-model="formData.sizeInput"
        :min="16"
        size="small"
        :max="72"
        label="请输入字号"
        placeholder=""
        @change="sizeChange"
      ></el-input-number>
    </div>
    <div class="base-input" style="width:auto;">
      <el-color-picker
        size="small"
        v-model="formData.colorInput"
        @change="colorChange"
      ></el-color-picker>
    </div>
    <div class="base-input" >
      <div class="base-group">
        <div
          :class="{ primary: formData.wightInput == 'bold' }"
          @click="wightChange('bold')"
        >
          B
        </div>
        <!-- I -->
        <!-- style="font-style: italic" -->
        <div
          class="last"
          :class="{ primary: formData.italicInput == 'italic' }"
          @click="italicChange('italic')"
          
        >
          /
        </div>
      </div>
    </div>
    <br>
   
     </div>

       <p style="color:red;font-size:14px;margin-top:10px">注:如果mac电脑选择字体不生效,请确认电脑中是否安装此字体(在搜索中查找：字体册)</p>
  </div>
 
</template>

<script>
export default {
  name: "createBase",
  data() {
    return {
      formData: {
        textInput: "",
        sizeInput: 22,
        familyInput: "STHeitiSC-Light",
        colorInput: "#409EFF",
        wightInput: "normal",
        italicInput: "normal",
      },
      options:[],
      optionsWindows: [
        {
          label: "黑体",
          value: "STHeitiSC-Light",
        },
        {
          label: "宋体",
          value: "SimSun",
        },
         {
          label: "仿宋",
          value: "FangSong",
        },
        {
          label: "楷体",
          value: "KaiTi",
        },
        {
          label: "隶书",
          value: "LiSu",
        },
         {
          label: "幼圆",
          value: "YouYuan",
        },
        // {
        //   label: "微软雅黑",
        //   value: "Microsoft YaHei",
        // },
       
        {
          label: "华文细黑",
          value: "STXihei",
        },
        //  {
        //   label: "行楷",
        //   value: "STKaiti",
        // },
        
      ],
      optionsMac: [
        {
          label: "黑体",
          value: "STHeitiSC-Light",
        },
        {
          label: "宋体",
          value: "STSong",
        },
        
          {
          label: "仿宋",
          value: "STFangsong",
        },

        {
          label: "楷体",
          value: "STKaitiSC-Regular",
        },
        {
          label: "隶书",
          value: "STLibianSC-Regular",
        },
        // {
        //   label: "行楷",
        //   value: "STXingkaiSC-Light",
        // },
        {
          label: "幼圆",
          value: "STYuanti-SC-Regular",
        },
        //  {
        //   label: "微软雅黑",
        //   value: "Microsoft YaHei",
        // },
        {
          label: "华文细黑",
          value: "STXihei",
        },
      ],
    };
  },
    created() {
      // this.$emit("_updateColor", this.formData.colorInput);
      this.initlist()
    },
  methods: {
       initlist() {
      var agent = navigator.userAgent.toLowerCase();
      var isMac = /macintosh|mac os x/i.test(navigator.userAgent);
      if (agent.indexOf("win32") >= 0 || agent.indexOf("wow32") >= 0||agent.indexOf("win64") >= 0 ||agent.indexOf("wow64") >= 0) {
        // alert("这是一个windows系统");
        this.options = this.optionsWindows
      }
      // if (agent.indexOf("win64") >= 0 || agent.indexOf("wow64") >= 0) {
      //   alert("这是一个windows64位系统");
      // }
      if (isMac) {
        // alert("这是一个mac系统");
        this.options = this.optionsMac

      }
    },
    colorChange(val) {
      this.$emit("cUpdateColor", val);
    },
    textChange(val) {
      this.$emit("cUpdateText", val);
    },
    sizeChange(val) {
      this.$emit("cUpdateSize", val + "px");
    },
    familyChange(val) {
      this.$emit("cUpdateFamily", val);
    },
    wightChange(val) {
      if (val == this.formData.wightInput) {
        // 取消选中
        this.formData.wightInput = "normal";
      } else {
        this.formData.wightInput = val;
      }
      this.$emit("cUpdateWeight", this.formData.wightInput);
    },
    italicChange(val) {
      if (val == this.formData.italicInput) {
        this.formData.italicInput = "normal";
      } else {
        this.formData.italicInput = val;
      }
      this.$emit("cUpdateItalic", this.formData.italicInput);
    },
  },
};
</script>

<style lang="scss" scoped>
.create-base {
  margin-top: 15px;
  align-items: center;
  .base-input{
   
    margin-right:20px;
  }
  .base-group {
    display: flex;
    div {
      width: 20px;
      height: 20px;
      text-align: center;
      line-height: 20px;
      cursor: pointer;
    }
    .last {
      margin-left: 5px;
    }
    .primary {
      background: rgb(208, 206, 202);
    }
  }
}
</style>



// WEBPACK FOOTER //
// createBase.vue?481d2d20